import Vue from 'vue'
import VueRouter from 'vue-router'

const Login = () => import('@/views/Login')
const TermsOfService = () => import('@/views/TermsOfService')
const NewRegistration = () => import('@/views/NewRegistration')
const NewRegistrationForm = () => import('@/views/NewRegistration/NewRegistrationForm')
const NewRegistrationConfirm = () => import('@/views/NewRegistration/NewRegistrationConfirm')
const NewRegistrationComplete = () => import('@/views/NewRegistration/NewRegistrationComplete')
const RegistrationComplete = () => import('@/views/RegistrationComplete')
const RequestPasswordReset = () => import('@/views/RequestPasswordReset')
const RequestPasswordResetForm = () => import('@/views/RequestPasswordReset/RequestPasswordResetForm')
const RequestPasswordResetComplete = () => import('@/views/RequestPasswordReset/RequestPasswordResetComplete')
const ResetPassword = () => import('@/views/ResetPassword')
const ResetPasswordForm = () => import('@/views/ResetPassword/ResetPasswordForm')
const ResetPasswordComplete = () => import('@/views/ResetPassword/ResetPasswordComplete')

Vue.use(VueRouter)

  const routes = [
  {
    path: '/login',
    name: 'login',
    meta: {
      isPublic: true,
      layout: 'front'
    },
    component: Login
  },
  {
    path: '/terms-of-service',
    name: 'terms-of-service',
    meta: {
      isPublic: true,
      layout: 'front'
    },
    component: TermsOfService
  },
  {
    path: '/new-registration',
    meta: {
      isPublic: true,
      layout: 'front'
    },
    component: NewRegistration,
    children: [
      {
        path: '/new-registration',
        name: 'new-registration',
        component: NewRegistrationForm,
        meta: { 
          isPublic: true,
          layout: 'front'
        }
      },
      {
        path: 'confirm',
        name: 'new-registration-confirm',
        component: NewRegistrationConfirm,
        meta: { 
          isPublic: true,
          layout: 'front'
        }
      },
      {
        path: 'complete',
        name: 'new-registration-complete',
        component: NewRegistrationComplete,
        meta: { 
          isPublic: true,
          layout: 'front'
        }
      },
    ]
  },
  {
    path: '/registered/:onetimeToken',
    name: 'registration-complete',
    meta: {
      isPublic: true,
      layout: 'front'
    },
    component: RegistrationComplete
  },
  {
    path: '/request-password-reset',
    meta: {
      isPublic: true,
      layout: 'front'
    },
    component: RequestPasswordReset,
    children: [
      {
        path: '/request-password-reset',
        name: 'request-password-reset',
        component: RequestPasswordResetForm,
        meta: {
          isPublic: true,
          layout: 'front'
        }
      },
      {
        path: 'complete',
        name: 'request-password-reset-complete',
        component: RequestPasswordResetComplete,
        meta: {
          isPublic: true,
          layout: 'front'
        }
      }
    ]
  },
  {
    path: '/reset-password/:onetimeToken',
    meta: {
      isPublic: true,
      layout: 'front'
    },
    component: ResetPassword,
    children: [
      {
        path: '/reset-password/:onetimeToken',
        name: 'reset-password',
        component: ResetPasswordForm,
        meta: {
          isPublic: true,
          layout: 'front'
        }
      },
      {
        path: 'complete',
        name: 'reset-password-complete',
        component: ResetPasswordComplete,
        meta: {
          isPublic: true,
          layout: 'front'
        }
      }
    ]
  },
  /* 初回リリースでは通さない */
  /*
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/Profile')
  },
  {
    path: '/payment-and-billing',
    name: 'payment-and-billing',
    component: () => import('@/views/PaymentAndBilling')
  },
  {
    path: '/support-tool',
    name: 'support-tool',
    component: () => import('@/views/SupportTool')
  },
  */
  {
    path: '/create-kokuban',
    name: 'create-kokuban',
    component: () => import('@/views/CreateKokuban'),
    alias: '/', // 初回リリースではrootで黒板作成画面
    children: [
      {
        path: 'detail/:cloudConstructionId',
        name: 'create-kokuban-detail',
        component: () => import('@/views/CreateKokuban/CreateKokubanFolder'),
        children: [
          {
            path: 'input',
            name: 'create-kokuban-input',
            component: () => import('@/views/CreateKokuban/CreateKokubanFolder/KokubanInput')
          },
          {
            path: 'output',
            name: 'create-kokuban-output',
            component: () => import('@/views/CreateKokuban/CreateKokubanFolder/KokubanOutput')
          }
        ]
      }
    ]
  },
  // 仮
  /* 初回リリースでは黒板作成に行くようにする */
  /*
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home')
  },*/
  // TODO 未定義(≒存在しないページ) 404ページなど必要？
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})

export default router
